export const PERMS = {
    READ: 'report_driver_allowances.read',
    UPDATE: 'report_driver_allowances.update',
    DELETE: 'report_driver_allowances.delete',
    CREATE: 'report_driver_allowances.create',
    EXPORT: 'report_driver_allowances.export',
}
